import { IApplicationState, TRegionCitiesState } from '../../types/redux';

export const selectRegionCities = (state: IApplicationState): TRegionCitiesState => {
  const { regionCities } = state.temp;

  return regionCities || [];
};
